module.exports = __webpack_public_path__ + "img/agent_2.15b0ef4f.png";